import React from "react";

function Servey() {
    return <div>Servey</div>;
}

export default Servey;
